import { render } from "./CardButton.vue?vue&type=template&id=3c15e031"
import script from "./CardButton.vue?vue&type=script&lang=js"
export * from "./CardButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__